import { getItemsText } from "../common/utilities";
import findByStrings from "../FindBy/strings";
const {
  resetAnnouncement,
  findButtonAriaLabel,
  resetButtonAriaLabel
} = findByStrings;
const STRINGS = {
  editPanelTitle: "Select Options",
  reorderPanelTitle: "Order Selections",
  saveButtonLabel: "Save",
  cancelButtonLabel: "Cancel",
  editButtonLabel: "Edit",
  reorderButtonLabel: "Reorder",
  moveToTopAriaLabel: "Move to top",
  moveUpAriaLabel: "Move up",
  moveDownArialLabel: "Move down",
  moveToBottomArialLabel: "Move to bottom",
  reorderPanelSelectedRowsMessage: selectedRowsCount => `${selectedRowsCount} selected`,
  feedbackInstruction: "",
  feedbackMinSelectionError: "",
  feedbackMaxSelectionError: "",
  editPanelSelectedRowsMessage: selectedRowsCount => `${selectedRowsCount} selected`,
  toolBarAriaLabel: "Toolbar",
  findAnnouncement: filteredRecordCount => getItemsText(filteredRecordCount),
  resetAnnouncement,
  findButtonAriaLabel,
  resetButtonAriaLabel,
  findByContainerAriaLabel: null,
  clearSelectionAriaLabel: "Clear selected items",
  clearSelectionDescription: "Resets selected items",
  selectionControlAriaLabel: "Selection controls",
  moveToTopDescription: "Move selected items to top of list",
  moveUpDescription: "Move selected items up one position",
  moveDownDescription: "Move selected items down one position",
  moveToBottomDescription: "Move selected items to bottom of list",
  moveToTopAnnouncement: selectedRows => `${selectedRows} items moved to top of list`,
  moveUpAnnouncement: selectedRows => `${selectedRows} items moved up one position`,
  moveDownAnnouncement: selectedRows => `${selectedRows} items moved down one position`,
  moveToBottomAnnouncement: selectedRows => `${selectedRows} items moved to bottom of list`,
  keyboardHelp: {
    action: "Action",
    cellNavigation: {
      up: {
        actionText: "Move up one cell",
        shortcutText: "Up arrow"
      },
      down: {
        actionText: "Move down one cell",
        shortcutText: "Down arrow"
      },
      left: {
        actionText: "Move left one cell",
        shortcutText: "Left arrow"
      },
      right: {
        actionText: "Move right one cell",
        shortcutText: "Right arrow"
      }
    },
    clearSelectedRows: {
      actionText: "Clear selected rows",
      shortcutText: "Shift + X"
    },
    close: "Close",
    moveSelectedRows: {
      up: {
        actionText: "Move selected rows up one row",
        shortcutText: "Shift + up arrow"
      },
      down: {
        actionText: "Move selected rows down one row",
        shortcutText: "Shift + down arrow"
      },
      toTop: {
        actionText: "Move selected rows to top of table",
        shortcutText: "Shift + control + up arrow"
      },
      toBottom: {
        actionText: "Move selected rows to bottom of table",
        shortcutText: "Shift + control + down arrow"
      }
    },
    navigationInstructions: "You can use the keyboard to navigate the table using the following keys:",
    panelShowHideInstructions: "ALT+K (Windows) / Option+K (Mac) for these keyboard instructions.",
    panelTitle: "Keyboard Help",
    selectedInstructions: "With rows selected:",
    shortcutKey: "Shortcut Key",
    toggle: {
      selectMode: {
        actionText: "Toggle select mode",
        shortcutText: "ALT+W (Windows) / Option+W (Mac)"
      },
      selectedRow: {
        actionText: "Select the row",
        shortcutText: "Space bar"
      }
    }
  }
};
export default STRINGS;